import Icon from '../components/Icon.vue'

Icon.register({"retweet":{"width":640,"height":512,"paths":[{"d":"M629.7 343.6L529 444.3C519.6 453.7 504.4 453.7 495 444.3L394.3 343.6C385 334.2 385 319 394.3 309.7L405.2 298.8C414.7 289.3 430.3 289.5 439.6 299.3L480 342.1V160H292.5A24-24 0 0 0 275.5 153L259.5 137C244.4 121.9 255.1 96 276.5 96H520C533.3 96 544 106.7 544 120V342.1L584.4 299.3C593.7 289.5 609.3 289.3 618.8 298.8L629.7 309.7C639 319 639 334.2 629.7 343.6zM364.5 359A24-24 0 0 1 347.5 352H160V169.9L200.4 212.7C209.7 222.5 225.3 222.7 234.8 213.2L245.7 202.3C255 193 255 177.8 245.7 168.4L145 67.7C135.6 58.3 120.4 58.3 111 67.7L10.3 168.4C1 177.8 1 193 10.3 202.3L21.2 213.2C30.7 222.7 46.3 222.5 55.6 212.7L96 169.9V392C96 405.3 106.7 416 120 416H363.5C384.9 416 395.6 390.1 380.5 375L364.5 359z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/retweet.js
// module id = xKmn
// module chunks = 0